import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie';

import { strings } from '../../localization/strings';
import ContainerMd from '../../components/common/containers/containerMd';
import AlertPrimary from '../../components/common/alerts/alert-primary';
import { COOKIE_NAME_ANSWER, COOKIE_NAME_ORDER_ANSWER } from '../../context/questionnaire';
import { storeMessagesCalendarAnswer } from '../../services/api/questionnaire';
import CommonAnimatedLoader from '../../components/common/animated/loader';
import { useAuth } from '../../hooks/use-auth';

const cookies = new Cookies();

export default function ConsultationSuccessPageComponent() {
  const { refreshUser } = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>();

  const [orderAnswerHash] = useState(() => cookies.get(COOKIE_NAME_ORDER_ANSWER));
  const [answerHash] = useState(() => cookies.get(COOKIE_NAME_ANSWER));
  const hasCalledRef = useRef(false);

  useEffect(() => {
    if (!orderAnswerHash || hasCalledRef.current) return;
    hasCalledRef.current = true;

    const onStoreAnswer = async () => {
      setIsLoading(true);
      try {
        const res = await storeMessagesCalendarAnswer(orderAnswerHash, answerHash);

        if (res) {
          await refreshUser();
          cookies.remove(COOKIE_NAME_ANSWER, { path: '/' });
          cookies.remove(COOKIE_NAME_ORDER_ANSWER, { path: '/' });
        }

        setIsLoading(false);
      } catch (e: any) {
        setIsLoading(false);
        setError(e.message);
      }
    };

    onStoreAnswer();
  }, []);

  return isLoading ? (
    <CommonAnimatedLoader />
  ) : (
    <div>
      <ContainerMd>
        <div className="md:w-9/12">
          <div className="mb-6 md:mb-10">
            {error ? (
              <AlertPrimary type="failed" title={error} />
            ) : (
              <>
                <AlertPrimary
                  type="success"
                  title={strings().consultationSuccess.success_title}
                  text={strings().consultationSuccess.success_text}
                />
                <div className="mt-10">
                  <NavLink
                    key="profile"
                    to="/"
                    className="!no-underline bg-content-300 text-content-900 hover:bg-content-400 inline-flex px-7 sm:px-9 text-base rounded-2xl py-3.5 font-bold"
                  >
                    {strings().checkout.previewProfile}
                  </NavLink>
                </div>
              </>
            )}
          </div>
        </div>
      </ContainerMd>
    </div>
  );
}
